<script setup lang="ts">
type Props = {
  label: string;
  disabled?: boolean;
};

defineProps<Props>();
</script>

<template>
  <div class="flex items-center gap-1.5" :class="[disabled ? 'opacity-50' : '']">
    <span class="text-sm font-bold">{{ label }}</span>
    <span class="text-primary min-w-7 rounded-full bg-gray-300 px-2 py-1 text-center text-[10px] font-bold">
      <slot />
    </span>
  </div>
</template>
